import { useTranslation } from 'react-i18next'
import { getPrivacyPolicyUrl } from '../../config/constants'
import { ButtonLocation } from '../../utils/analyticsEvents'
import { StoreButtons } from '../StoreButtons/StoreButtons'
import styles from './Footer.module.scss'

export const Footer = () => {
  const { t, i18n } = useTranslation()

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.copyright}>
          <p>{t('footer.copyright')}</p>
          <a
            className={styles.privacy}
            href={getPrivacyPolicyUrl(i18n.language)}
            rel="noreferrer"
            target="_blank"
          >
            {t('footer.privacy')}
          </a>
        </div>
        <div>
          <p className={styles.appsTitle}>{t('footer.appsTitle')}</p>
          <StoreButtons className={styles.stores} location={ButtonLocation.Footer} variant="white" />
        </div>
      </div>
    </footer>
  )
}
